import { render, staticRenderFns } from "./MeusDadosA7.vue?vue&type=template&id=4fedef76&scoped=true"
import script from "./MeusDadosA7.vue?vue&type=script&lang=js"
export * from "./MeusDadosA7.vue?vue&type=script&lang=js"
import style0 from "./MeusDadosA7.vue?vue&type=style&index=0&id=4fedef76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fedef76",
  null
  
)

export default component.exports